/*
 * lazy-hidden-dom.js — ЗМІНА 16.09.2026
 *
 * Проблема: частина розмітки рендериться двічі — окремо для десктопа і для
 * мобільного — і на кожному екрані одна з копій прихована (display:none), але
 * живе в DOM: мобільне меню (~220 вузлів) на десктопі, мобільні фільтри
 * (~300) на десктопі, десктопні фільтри (~230) на мобільному.
 * Футер (ЗМІНА 16.09.2026, друга ітерація): меню-блоки футера теж рендеряться
 * двічі — акордеон для мобільного (.accordion > details) і відкритий список
 * для десктопа (.footer-block--menu). Приховану копію так само виносимо з DOM.
 *
 * Що робимо: після DOMContentLoaded (тобто коли global.js і facets.js уже
 * оживили свої елементи й повісили обробники) переносимо ВНУТРІШНІЙ вміст
 * прихованих контейнерів у DocumentFragment. Самі контейнери лишаються на
 * місці, тому всі getElementById / closest у темі працюють як раніше.
 * Вузли переносяться, а не копіюються — обробники подій на них зберігаються.
 *
 * Повертаємо вміст:
 *   - коли контейнер стає видимим (зміна ширини / поворот екрана);
 *   - facets: перед будь-яким перерендером фільтрів (renderPage) — назавжди
 *     для цього перегляду сторінки, щоб facets.js бачив обидві форми, як і до правки.
 *
 * HTML від сервера не змінюється: пошуковики й користувачі без JS бачать усе.
 * Щоб вимкнути — прибрати підключення цього файлу в snippets/meta-tags.liquid.
 */
(function () {
	'use strict';

	var TARGETS = [
		{
			name: 'menu-drawer',
			hosts: function () { return one(document.querySelector('header-drawer #menu-drawer')); },
			box: function (host) { return host.closest('header-drawer'); },
			keep: null
		},
		{
			name: 'facets-mobile',
			hosts: function () { return one(document.getElementById('FacetFiltersFormMobile')); },
			box: function (host) { return host.closest('details'); },
			keep: null
		},
		{
			name: 'facets-desktop',
			hosts: function () { return one(document.getElementById('FacetFiltersForm')); },
			box: function (host) { return host.closest('facet-filters-form'); },
			/* product-grid.js міряє .facets__sort-wrapper через ResizeObserver */
			keep: '.facets__sort-wrapper'
		},
		{
			/* Мобільний акордеон футера. Порожнимо саме <details>, а не .accordion:
			   у CSS є правило .accordion:empty + .footer-block, яке інакше спрацювало б.
			   Обробники footer.js висять на самих <details> — вони лишаються на місці. */
			name: 'footer-accordion',
			hosts: function () { return [].slice.call(document.querySelectorAll('.footer .accordion > details')); },
			box: function (host) { return host.closest('.accordion'); },
			keep: null
		},
		{
			/* Десктопний список меню футера (на мобільному .footer-block--menu { display:none }) */
			name: 'footer-menu',
			hosts: function () { return [].slice.call(document.querySelectorAll('.footer .footer-block--menu')); },
			box: function (host) { return host; },
			/* Заголовок лишаємо: у base.css є div:empty { display:none } — порожній блок
			   став би прихованим і на десктопі вже не повернувся б */
			keep: '.footer-block__heading'
		}
	];

	function one(el) { return el ? [el] : []; }

	var state = [];

	function isHidden(el) {
		return !el || el.getClientRects().length === 0;
	}

	function detach(item) {
		if (item.runs || item.pinned) return;
		/* Відкладаємо суцільні ділянки дочірніх вузлів; кожну — у свій фрагмент
		   з маркером-коментарем на її місці. Так точний порядок вузлів
		   відновлюється навіть коли між ділянками лишаються item.keep-елементи. */
		var runs = [];
		var current = null;
		var node = item.hostEl.firstChild;
		while (node) {
			var next = node.nextSibling;
			var keepIt = item.keep && node.nodeType === 1 && (node.matches(item.keep) || node.querySelector(item.keep));
			if (keepIt) {
				current = null;
			} else {
				if (!current) {
					current = { marker: document.createComment('lazy-dom:' + item.name), frag: document.createDocumentFragment() };
					item.hostEl.insertBefore(current.marker, node);
					runs.push(current);
				}
				current.frag.appendChild(node);
			}
			node = next;
		}
		item.runs = runs.length ? runs : null;
	}

	function restore(item) {
		if (!item.runs) return;
		item.runs.forEach(function (run) {
			if (run.marker.parentNode) run.marker.parentNode.replaceChild(run.frag, run.marker);
		});
		item.runs = null;
	}

	function check() {
		state.forEach(function (item) {
			if (isHidden(item.boxEl)) detach(item); else restore(item);
		});
	}

	function init() {
		TARGETS.forEach(function (t) {
			t.hosts().forEach(function (hostEl) {
				var boxEl = t.box(hostEl);
				if (!boxEl) return;
				state.push({ name: t.name, hostEl: hostEl, boxEl: boxEl, keep: t.keep, runs: null, pinned: false });
			});
		});
		if (!state.length || (window.Shopify && Shopify.designMode)) return;

		/* facets.js перемальовує обидві форми — перед цим повертаємо все назавжди */
		/* class-оголошення з facets.js не стає властивістю window — перевіряємо через typeof */
		if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
			var origRenderPage = FacetFiltersForm.renderPage;
			FacetFiltersForm.renderPage = function () {
				state.forEach(function (item) {
					if (item.name.indexOf('facets') === 0) { restore(item); item.pinned = true; }
				});
				return origRenderPage.apply(this, arguments);
			};
		}

		check();

		var t;
		function schedule() {
			clearTimeout(t);
			t = setTimeout(check, 200);
		}
		window.addEventListener('resize', schedule, { passive: true });
		/* Частина CSS (зокрема section-footer.css) підключена асинхронно (media=print + onload):
		   на момент init прихований блок ще може бути видимим. Перевіряємо повторно,
		   коли довантажується будь-який stylesheet, і на load. */
		document.addEventListener('load', function (e) {
			var el = e.target;
			if (el && el.tagName === 'LINK' && /stylesheet/i.test(el.rel)) schedule();
		}, true);
		window.addEventListener('load', schedule);
	}

	/* Після DOMContentLoaded (+ один такт): на цей момент усі defer-скрипти теми
	   (global.js, facets.js) уже виконані й оживили свої елементи. На load не
	   чекаємо — на сайті він може настати дуже пізно через сторонні ресурси.
	   Перевірено: у мобільному меню й фільтрах немає обробників, що вішаються на load. */
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
	} else {
		setTimeout(init, 0);
	}
})();
